// API error codes
export const EC_OL_PRE_ENDED = '011-09';
export const EC_OL_POST_ENDED = '011-10';
export const WARNING_MAX_DAILY_WORKSHEETS_REACHED = 1;
export const WARNING_MAX_TOPICAL_WORKSHEETS_REACHED = 2;